class Registration {
  constructor(elem) {
    this.elem = elem;
  }

  initialize() {
    const that = this;
    let link = this.elem.find('[data-login-link]');

    link.on('click', () => {
      link.closest('[data-tabs-auth]').find('[data-tabs-head]').children().eq(0).trigger('click');

      setTimeout(() => {
        $('html, body').animate({scrollTop: '0px'}, 500);
      }, 300);
    });

    let form = this.elem.find('[data-registration-form]');
    let profileBtn = $('[ data-profile-personal-submit]');

    profileBtn.on('click', function() {
      form.find(':submit').trigger('click');
    });
  }
}

export {Registration}

$(window).ready(function() {
  let registration = [];

  if ($('[data-registration]').length > 0) {
		$('[data-registration]').each(function(i) {
			registration[i] = new Registration($(this));
			registration[i].initialize();
		});
	}
});
